import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import TestimonialSection from "../components/TestimonialSection";

const BRAND_COLOR = "#1a3f6b";
const GRAY_DARK = "#374151";

export default function Testimonials() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <>
      <Navbar />

      {/* Page header */}
      <section
        style={{
          padding: isMobile ? "100px 1.5rem 3rem" : "120px 2rem 4rem",
          background: "#fff",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              background: "rgba(16,185,129,0.1)",
              border: "1px solid rgba(16,185,129,0.3)",
              color: "#10b981",
              fontSize: "0.78rem",
              fontWeight: 700,
              borderRadius: "6px",
              padding: "0.3rem 0.75rem",
              marginBottom: "1rem",
              letterSpacing: "0.04em",
              textTransform: "uppercase",
            }}
          >
            Testimonials
          </div>
          <h1
            style={{
              fontSize: isMobile ? "2rem" : "3rem",
              fontWeight: 800,
              color: BRAND_COLOR,
              lineHeight: 1.15,
              letterSpacing: "-0.02em",
              margin: 0,
            }}
          >
            What real agents are saying
          </h1>
          <p
            style={{
              color: GRAY_DARK,
              opacity: 0.7,
              fontSize: isMobile ? "1rem" : "1.1rem",
              lineHeight: 1.6,
              marginTop: "1rem",
              maxWidth: "640px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            Stories from agents using Vendorleads to nurture their database,
            spot warm vendors, and turn quiet contacts into listing
            conversations.
          </p>
        </div>
      </section>

      {/* All three testimonials, stacked */}
      <TestimonialSection isMobile={isMobile} testimonial="ashley" />
      <TestimonialSection isMobile={isMobile} testimonial="liam" />
      <TestimonialSection isMobile={isMobile} testimonial="barbara" />
    </>
  );
}
